var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-arrow-up"}}),_vm._v("\n        Back to top\n    ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }